export type LocationRole = 'hauptstandort' | 'secondary'

export type Location = {
  id: string
  role: LocationRole
  name: string
  address: string
  mapsUrl: string
  hint?: string
  hintUrl?: string
  bookingUrl: string
  bookingLabel: string
}

export const phoneNr = '044 554 90 66'
export const email = 'info@physiozueriwest.ch'

export const locations: Location[] = [
  {
    id: 'altstetten',
    role: 'hauptstandort',
    name: 'PhysioZüriWest Praxis Altstetten',
    address: 'Hohlstrasse 488, 8048 Zürich',
    mapsUrl: 'https://goo.gl/maps/DcKD1herPjufeUU8A',
    hint: "Bahnhof Altstetten 7' zu Fuss",
    hintUrl: 'https://goo.gl/maps/qJqrbLDg9rZLh8sN8',
    bookingUrl:
      'https://onlinecalendar.medidoc.ch/BookAppointment?cgid=t82xtm7Tk0q_l0gpU7zyCA&ssid=T3jR4DKfj0yrLDvXEacIRg',
    bookingLabel: 'Online Terminvereinbarung',
  },
  {
    id: 'crossfit',
    role: 'secondary',
    name: 'PhysioZüriWest im Crossfit Zürich',
    address: 'Hardstrasse 81, 8004 Zürich',
    mapsUrl:
      'https://www.google.com/maps/search/?api=1&query=Hardstrasse+81+8004+Z%C3%BCrich',
    hint: "Bahnhof Hardbrücke 8' zu Fuss",
    hintUrl: 'https://maps.app.goo.gl/1Uc2yKMhF6Sq5VTo7',
    bookingUrl:
      'https://onlinecalendar.medidoc.ch/BookAppointment?cgid=_iPvlPi9V0iL6AsRUWIQjA&ssid=tSgsQG0TskKG1m_pRG5UWA',
    bookingLabel: 'Online Terminvereinbarung',
  },
]
